// extracted by mini-css-extract-plugin
export var button = "productCard-module--button--eb2be";
export var cafeFormIntro = "productCard-module--cafe-form-intro--57935";
export var card = "productCard-module--card--d2412";
export var cardTitle = "productCard-module--card-title--494f1";
export var cardWrapper = "productCard-module--card-wrapper--fa556";
export var cta = "productCard-module--cta--0b1c4";
export var highlight = "productCard-module--highlight--3f2d6";
export var redButton = "productCard-module--red-button--36b98";
export var redTransparentButton = "productCard-module--red-transparent-button--1acb1";
export var title = "productCard-module--title--b452b";
export var transparentButton = "productCard-module--transparent-button--d127b";